// Merchant subscription / wallet billing (REQ-20260716-02).
// Registers Settings → Subscription route. Sidebar menu + plan card use FORK_PATCH.
import SubscriptionPage from './components/SubscriptionPage.vue';
import SidebarPlanCard from './components/SidebarPlanCard.vue';

export const SUBSCRIPTION_ROUTE = 'custom_subscription';

const addRoute = (router, route) => {
  if (router.hasRoute(route.name)) return;
  if (router.hasRoute('app_container')) {
    router.addRoute('app_container', route);
  } else {
    router.addRoute(route);
  }
};

export const installBilling = ({ app, router }) => {
  if (app) {
    app.component('SidebarPlanCard', SidebarPlanCard);
  }

  if (!router) return;

  addRoute(router, {
    name: SUBSCRIPTION_ROUTE,
    path: '/app/accounts/:accountId/custom/subscription',
    component: SubscriptionPage,
    meta: { permissions: ['administrator'] },
  });
};

export default installBilling;
